<template>
    <div class="select">

        <header-back></header-back>

        <ul class="level-list">
            <li>
                <router-link :to="'/' + route + '/1'">
                    <p>Level 1</p>
                </router-link>
            </li>
            <li>
                <router-link :to="'/' + route + '/2'">
                    <p>Level 2</p>
                </router-link>
            </li>
            <li>
                <router-link :to="'/' + route + '/3'">
                    <p>Level 3</p>
                </router-link>
            </li>
            <li>
                <router-link :to="'/' + route + '/4'">
                    <p>Level 4</p>
                </router-link>
            </li>
            <li>
                <router-link :to="'/' + route + '/5'">
                    <p>Level 5</p>
                </router-link>
            </li>
        </ul>
    </div>
</template>

<script>
    import headerBack from '../components/Header';
    export default {
        data() {
            return {
                route: this.$route.params.route
            }
        },
        components: {
            headerBack
        }
    }
</script>